import { render, staticRenderFns } from "./PersonalStatsCalendar.vue?vue&type=template&id=81528306"
import script from "./PersonalStatsCalendar.vue?vue&type=script&lang=js"
export * from "./PersonalStatsCalendar.vue?vue&type=script&lang=js"
import style0 from "./PersonalStatsCalendar.vue?vue&type=style&index=0&id=81528306&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports